export const POSTHOG_COOKIE_EXPIRE_IN_SECONDS = 2 * 24 * 60 * 60;
export const POSTHOG_COOKIE_NAME = 'abexp';
export const SANITY_VARIANT_PAGE_SLUG_PREFIX = 'abtest';
